//= require personalised-bundle-state.js
//= require personalised-storage-manager.js
// CUSTOM: personalised-bundle-listeners.js - Centralized event listeners for bundle system

(function() {
  'use strict';

  // Safety check - ensure namespace exists
  if (typeof window.personalised === 'undefined') {
    console.warn('[Bundle Listeners] window.personalised namespace not found. Initialization may fail.');
    window.personalised = {};
  }
  
  /**
   * Initialize bundle event listeners for login state
   * Sets up listeners to handle login state changes and cleanup
   */
  function initializeBundleLoginListeners() {
    // Only set up listeners once
    if (window.personalised._loginListenersInitialized) {
      console.debug('[Bundle Listeners] Login listeners already initialized');
      return;
    }
    
    console.debug('[Bundle Listeners] Setting up login state change listeners');
    
    // Listen for login state change events
    window.addEventListener('personalised:loginStateChanged', function(event) {
      console.debug('[Bundle Listeners] Login state change detected:', event.detail);
      
      // Only handle logout events (when user is no longer logged in)
      if (!event.detail.loggedIn) {
        console.log('[Bundle Listeners] Logout detected, cleaning up bundle state');
        
        // Clean up bundle state if available
        if (window.personalised?.bundle?.teardown) {
          window.personalised.bundle.teardown();
        }
        
        // Clean up storage if available
        if (window.personalised?.storageManager?.clearAllPersonalisedData) {
          window.personalised.storageManager.clearAllPersonalisedData();
        }
      }
    });
    
    // Mark listeners as initialized
    window.personalised._loginListenersInitialized = true;
  }
  
  // Auto-initialize when script loads
  initializeBundleLoginListeners();
  
  // Expose the function publicly in case it needs to be called manually
  window.personalised.initializeBundleLoginListeners = initializeBundleLoginListeners;
})();
